import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Contratacion } from 'src/app/models/Contratacion';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Catalogo } from 'src/app/models/Catalogo';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { NumIdTipCatTipoSelec, NumIdTipCatModalidad, NumIdTipCatTipoCompra, NumIdTipCatMoneda, iconAgregar, DscTituloPaginator, ngClassAceptarModal, ngClassSalirModal, GetDateTimeString, dscEtiquetaBtnAcepModal, dscEtiquetaBtnSalirModal, openModalMensaje, iconEditar, iconEliminar, StrDscToolTipText, recupToolTipCar, strMatTablePaginator } from 'src/app/general/variables';
import { Anho } from 'src/app/models/Anho';
import { AnhoService } from 'src/app/services/Anho.service';
import { FichaXConratacionXHi } from 'src/app/models/FichaXContratacionXHi';
import { ModalRegHechoirreContrComponent } from '../modal-reg-hechoirre-contr/modal-reg-hechoirre-contr.component';
import { FichaXContratacion } from 'src/app/models/FichaXContratacion';
import { Entidad } from 'src/app/models/Entidad';
import { BusqEntidadComponent } from '../../general/busq-entidad/busq-entidad.component';

@Component({
  selector: 'app-modal-reg-contratacion',
  templateUrl: './modal-reg-contratacion.component.html',
  styleUrls: ['./modal-reg-contratacion.component.css']
})
export class ModalRegContratacionComponent implements OnInit {

  listTipSeleccion: Catalogo[] = [];
  listModalidad: Catalogo[] = [];
  listTipComp: Catalogo[] = [];
  listAnhoConv: Anho[] = [];
  listMoneda: Catalogo[] = [];
  listHechoIrregular: FichaXConratacionXHi[] = [];
  fichaXContratacion: FichaXContratacion = new FichaXContratacion();

  strDscTitulo = 'Registro del Proceso de Selección';
  strFchPub = '';
  iconoAgregar = iconAgregar;
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  dscEtiquetaBtnAcepModal = dscEtiquetaBtnAcepModal;
  dscEtiquetaBtnSalirModal = dscEtiquetaBtnSalirModal;
  iconEditar = iconEditar;
  iconEliminar = iconEliminar;

  strDscTooltip: string = StrDscToolTipText;

  dataSource: MatTableDataSource<FichaXConratacionXHi>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matTableColumnsDef = ['item', 'hechosirreg', 'editar', 'eliminar'];
  matTableColumnsEtiq = ['Ítem', 'Tema del presunto hecho irregular', 'Editar', 'Eliminar'];
  strMatTablePaginator = strMatTablePaginator;

  contratacion: Contratacion = new Contratacion();

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;
  @ViewChild(BusqEntidadComponent) busqEntidadC: BusqEntidadComponent;

  constructor(private dialogRef: MatDialogRef<ModalRegContratacionComponent>,
              public dialog: MatDialog,

              @Inject(MAT_DIALOG_DATA) public data: any,
              protected catalogoService: CatalogoService,
              protected anhoService: AnhoService,

    ) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2(this.strDscTitulo);

    // this.fichaXContratacion = this.data.fichaXContr;

    this.catalogoService.listarCatalogo(NumIdTipCatTipoSelec).subscribe(
      data => {

        this.listTipSeleccion = data;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatModalidad).subscribe(
      data => {

        this.listModalidad = data;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatTipoCompra).subscribe(
      data => {

        this.listTipComp = data;

      });

    this.anhoService.listarAnho().subscribe(
      data => {

        this.listAnhoConv = data;

      });

    this.catalogoService.listarCatalogo(NumIdTipCatMoneda).subscribe(
      data => {

        this.listMoneda = data;

      });

  }

  _cambioDescripcion() {

    this.strDscTooltip = recupToolTipCar(this.contratacion.ccontratacionDscdirlegent);


  }

  _setCodEntidadOut(entidadSelec: Entidad) {

    this.contratacion.ccontratacionCodent = entidadSelec.centCodigo;
    this.contratacion.ccontratacionNroruc = entidadSelec.centRuc;
    this.contratacion.ccontratacionCdepent = entidadSelec.centDirdep;
    this.contratacion.ccontratacionCprovent = entidadSelec.centDirpro;
    this.contratacion.ccontratacionCdistent = entidadSelec.centDirdis;

  }

  _abrirModalIrregularidad() {

    let vListHechoIrregular: FichaXConratacionXHi[] = [];

    vListHechoIrregular = JSON.parse( JSON.stringify( this.listHechoIrregular) );

    const dialogRef = this.dialog.open(ModalRegHechoirreContrComponent, {
      // width: '50%',height:'87%',
      width: '80%', height: '87%',
      data: {listHi : vListHechoIrregular}});

    dialogRef.afterClosed().subscribe(result => {

      if (result != null) {
        this.listHechoIrregular = result;
        this._cargarTableMaterial();
      }

    });

  }

  _cargarTableMaterial() {

    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.listHechoIrregular);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 10);

  }


  _dateChanged(event: any) {

    if (event.value) {

      this.strFchPub = event.value.toString();


    }


  }

  _eliminar(row: FichaXConratacionXHi) {

    this.listHechoIrregular.splice(this.listHechoIrregular.indexOf(row), 1);
    this._cargarTableMaterial();

  }

  _cambioMonto(data: string, numCaso: number) {

    switch (numCaso) {
      case 1:

        this.contratacion.strNcontratacionImpmonto = data;

        break;

      case 2:

        this.contratacion.strNcontratacionImpvalorest = data;

        break;

      default:
        break;
    }


  }

  _aceptar() {

    const vDscMsjErr =  null;

    // console.log("this.contratacion.ncontratacionImpmonto",this.contratacion.ncontratacionImpmonto);


    // if(this.contratacion.ccontratacionDscnomenclatura == null)
    //   {

    //     vDscMsjErr = `la nomenclatura`;

    //   }else if(this.contratacion.ccontratacionDscobjcont == null)
    //   {

    //     vDscMsjErr = `el objeto de contratación`;

    //   }else if(this.contratacion.ccontratacionDscobjeto == null)
    //   {

    //     vDscMsjErr = `la descripción del objeto`;

    //   }else if(this.contratacion.strNcontratacionImpmonto == null)
    //   {

    //     vDscMsjErr = `el Monto de Derecho`;

    //   }

    //   if(vDscMsjErr != null)
    //   {

    //     openModalMensaje(this.strDscTitulo,`Ingrese ${vDscMsjErr}, por favor verifique`,this.dialog).afterClosed().subscribe(result=>{

    //     });

    //     return;

    //   }

    if (this.strFchPub != null) {

      this.contratacion.strDcontratacionFchpublic = GetDateTimeString(this.strFchPub);

    }

    if (this.contratacion.strNcontratacionImpmonto != null && this.contratacion.strNcontratacionImpmonto != '') {

      this.contratacion.ncontratacionImpmonto = Number(this.contratacion.strNcontratacionImpmonto.replace(/,/g, ''));

    }

    if (this.contratacion.strNcontratacionImpvalorest != null && this.contratacion.strNcontratacionImpvalorest != '') {

      this.contratacion.ncontratacionImpvalorest = Number(this.contratacion.strNcontratacionImpvalorest.replace(/,/g, ''));

    }


    if (this.contratacion.ncontratacionIdtiposelecc > 0) {

      this.contratacion.ccontratacionDsctipselecc = this.listTipSeleccion.find(x => x.ncatalogoId == this.contratacion.ncontratacionIdtiposelecc).ccatalogoDsc;

    }

    if (this.contratacion.ncontratacionIdmodaselecc > 0) {

      this.contratacion.ccontratacionDscmodaselecc = this.listModalidad.find(x => x.ncatalogoId == this.contratacion.ncontratacionIdmodaselecc).ccatalogoDsc;

    }

    if (this.contratacion.ncontratacionIdtipcompra > 0) {

      this.contratacion.ccontratacionDsctipcompra = this.listTipComp.find(x => x.ncatalogoId == this.contratacion.ncontratacionIdtipcompra).ccatalogoDsc;

    }

    if (this.contratacion.ncontratacionIdmoneda > 0) {

      this.contratacion.ccontratacionDscmoneda = this.listMoneda.find(x => x.ncatalogoId == this.contratacion.ncontratacionIdmoneda).ccatalogoDsc;

    }

    this.fichaXContratacion.contratacion = this.contratacion;
    this.fichaXContratacion.listaFichaPorContratacionPorHechoIrregular = this.listHechoIrregular;

    this.dialogRef.close(this.fichaXContratacion);

  }

  _cancelar() {

    this.dialogRef.close();

  }

}
